import { httpsCallable } from "firebase/functions";
import { Functions } from "./firebase";

export async function enrichTaskQuery(taskListId, taskQuery) {
  const previewTaskFunction = httpsCallable(Functions, "enrichTaskQuery");
  const result = await previewTaskFunction({ taskListId, query: taskQuery });

  // @ts-ignore
  return result.data?.result;
}